// @ts-nocheck
import * as React from 'react';
import { MessageCircleQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';
import useAssistantStore from '@/store/assistantStore';
import HelpDrawer from './HelpDrawer';

/**
 * Stripe-style AI help assistant: a floating help button (bottom-right, every
 * authenticated admin page — mounted in OrganizationLayout) that opens a
 * right-side chat drawer grounded in the Staty docs + this org's live data.
 */
export default function HelpAssistant({ league }) {
  const isOpen = useAssistantStore((s) => s.isOpen);
  const open = useAssistantStore((s) => s.open);

  if (!league?._id) return null;

  return (
    <>
      {!isOpen && (
        <Button
          onClick={open}
          size="icon"
          aria-label="Open help assistant"
          className="fixed bottom-6 right-6 z-50 h-12 w-12 rounded-full shadow-lg"
        >
          <MessageCircleQuestion className="h-6 w-6" />
        </Button>
      )}
      <HelpDrawer league={league} />
    </>
  );
}
